import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { InformesService } from 'app/services/informes.service';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-bitacora-info-benef',
  templateUrl: './bitacora-info-benef.component.html',
  styleUrls: ['./bitacora-info-benef.component.scss']
})
export class BitacoraInfoBenefComponent implements OnInit {

  //DataTable
  public dtOptions;
  public tableOpt;
  @ViewChild(DataTableDirective, {static: true})
  tabla: DataTableDirective;
  public dtTrigger: Subject<void>

  constructor(private _informe: InformesService) { 
    this.dtTrigger = new Subject();
    this.dtTrigger.next();

    this.tableOpt = [];
    this.dtOptions = {
      columns: [
        {
          title: ''
        },
        {
          title: 'Promedio Servicios',
          data: 'promeServAde'
        },
        {
          title: 'Total Servicios',
          data: 'total_servicios'
        },
        {
          title: 'Meses',
          data: 'PerTiempoBen'
        },
        {
          title: 'Documento',
          data: 'bendoc'
        },
        {
          title: 'Nombre Completo',
          data: 'bennom'
        },
        {
          title: 'Servicios Antes',
          data: 'total_servicios_antes'
        },
        {
          title: 'Servicios Después',
          data: 'total_servicios_despues'
        },
        {
          title: 'Radicado',
          data: 'grugru'
        },
        {
          title: 'Ingreso',
          data: 'bening'
        },
        {
          title: 'Servicio Adecuado Total',
          data: 'servAdeTotal'
        },
        {
          title: 'Fecha Ingreso AP',
          data: 'ApoUsuDataini'
        },
        {
          title: 'Fecha Ingreso Aud',
          data: 'ApoUsuDataAud'
        }
      ]
    }
  }

  @Input() doc_beneficiario: string;

  ngOnInit() {
    this._informe.SeguimientoBeneficiario(this.doc_beneficiario).subscribe((data:any) => {
      console.log(data);
    })
  }

}
